module.exports = __webpack_public_path__ + "img/return_training.b8a0738e.jpeg";